/* eslint-disable */
import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import moment from "moment";
import { Globel } from "./globel";
import * as req from "./utils/request";
import { getFontSize } from "@/utils/fontsize";
import emojiRegex from "emoji-regex";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$moment = moment;
Vue.prototype.$req = req;
Vue.prototype.$regex = emojiRegex();
let globel = new Globel();
window.$globel = globel;

// 定义混入变量
Vue.mixin({
  data() {
    return {
      globel: window.$globel,
    };
  },
  methods: {
    // handFocus (val) {
    //   this.$nextTick(() => {
    //     const triggerRect = val.$el
    //     // 计算下拉框的新位置
    //     const top = triggerRect.offsetTop + window.scrollY + 40
    //     const left = triggerRect.offsetLeft + window.scrollX
    //     document.documentElement.style.setProperty('--top-date', top + 'px')
    //     document.documentElement.style.setProperty('--left-date', left + 'px')
    //   })
    // },
    // handleVisibleChange (val, type) {
    //   if (val) {
    //     this.$nextTick(() => {
    //       const selectInstance = this.$refs[type]
    //       if (selectInstance) {
    //         // 获取触发下拉的按钮的位置
    //         const triggerRect = selectInstance.$el
    //         // 计算下拉框的新位置
    //         const top = triggerRect.offsetTop + window.scrollY + 40
    //         const left = triggerRect.offsetLeft + window.scrollX
    //         // 设置下拉框的位置
    //         document.documentElement.style.setProperty('--top-cascader', top + 'px')
    //         document.documentElement.style.setProperty('--left-cascader', left + 'px')
    //       }
    //     })
    //   }
    // },
    vhToPx(vh) {
      // 687.45
      const px = (window.innerHeight * vh) / 100;
      return Math.round(px);
    },
    getGlobelSize(res) {
      return Math.round(getFontSize(res));
    },
  },
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
